var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.marker)?_c('l-marker',{attrs:{"lat-lng":_vm.marker.position,"title":_vm.marker.title,"draggable":false,"icon":_vm.markerIcon(_vm.marker)}},[_c('l-popup',[_vm._v("\n      "+_vm._s(_vm.marker.text)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }